import {
  Component,
  ViewEncapsulation
} from '@angular/core';



export class MdlLayoutTitleComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-title',
  host: {
    '[class.mdl-layout-title]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
